<app-pias-layout>
    <div pias-layout-content>
        <br>
        @if (isLoading) {
        <p>Loading...</p>
        }

        <h4 class="page-header">Create Campaign</h4>
        <div class="campaign-details-container" [formGroup]="campaignForm">

            <div class="section-card">
                <div class="container-fluid">
                    <div class="row">

                        <div class="form-row">
                            <label class="field-label">Campaign Name</label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="campaignName" placeholder="Enter Campaign Name">
                                @if (
                                this.campaignForm.controls['campaignName'].invalid &&
                                (this.campaignForm.controls['campaignName'].touched ||
                                this.campaignForm.controls['campaignName'].dirty)
                                ) {
                                <mat-error>
                                    @if (this.campaignForm.controls['campaignName'].errors?.['required']) {
                                    <span>{{ message }}</span>
                                    } @else {
                                    <span></span>
                                    }
                                </mat-error>
                                }
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <label class="field-label">Channel</label>
                            <div class="w-100 mt-1">
                                <div class="btn-group" role="group">
                                    <button type="button" class="btn custom-toggle-btn"
                                        [class.active-btn]="selectedChannel === 'email'"
                                        (click)="switchChannel('email')">
                                        <mat-icon>email</mat-icon> email
                                    </button>

                                    <button type="button" class="btn custom-toggle-btn"
                                        [class.active-btn]="selectedChannel === 'whatsapp'"
                                        (click)="switchChannel('whatsapp')">
                                        <mat-icon>chat</mat-icon> Whatsapp
                                    </button>

                                    <button type="button" class="btn custom-toggle-btn"
                                        [class.active-btn]="selectedChannel === 'sms'" 
                                        (click)="switchChannel('sms')">
                                        <mat-icon>sms</mat-icon> SMS
                                    </button>
                                </div>
                            </div>
                        </div>


                        <div class="form-row">
                            <label class="field-label">Select Template</label>
                            <mat-form-field class="w-100">
                                <mat-label>Choose a template</mat-label>
                                <mat-select formControlName="template">
                                    @for (template of templates; track template.value) {
                                    <mat-option [value]="template.value">{{template.viewValue}}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>



                        <!-- @if (activeTemplate) {
    <div class="form-row col-12 w-100">
        <label class="field-label">Template Preview</label>
        
        <div class="w-100 mt-1">
            <div class="template-preview-wrapper w-100 mb-4">
                
                @if (activeTemplate.subject) {
                    <div class="preview-header">
                        <strong>Subject:</strong> {{ activeTemplate.subject }}
                    </div>
                }
                
                <div class="preview-body p-0"> @if (selectedChannel === 'email') {
                        <iframe 
                            [srcdoc]="activeTemplate.htmlContent" 
                            class="email-preview-frame"
                            sandbox="allow-same-origin">
                        </iframe>
                    } @else {
                        <div class="p-3"> <pre class="whatsapp-preview-text">{{ activeTemplate.htmlContent }}</pre>
                        </div>
                    }
                </div>
                
            </div>
        </div>
    </div>
} -->

                        <div class="form-row">
                            <label class="field-label">Upload Contact List</label>

                            <div class="file-upload-wrapper w-100">
                                <button mat-raised-button color="primary" type="button" (click)="fileInputCsv.click()"
                                    class="upload-btn">
                                    <mat-icon>cloud_upload</mat-icon>
                                    Upload CSV File
                                </button>

                                <input #fileInputCsv type="file" hidden accept=".csv" (change)="onFileSelected($event)">

                                @if (selectedFileName) {
                                <span class="file-name">{{ selectedFileName }}</span>
                                }
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="form-actions mt-4">
                <button class="save-btn" type="button" (click)="onCreateCampaign()">
                    <span>Create Campaign</span>
                    <mat-icon>arrow_forward</mat-icon>
                </button>
                <button class="cancel-btn" type="button" (click)="onCancel()">
                    <span>Cancel</span>
                </button>
            </div>

        </div>
    </div>
</app-pias-layout>